"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMax = withMax;
var _react = _interopRequireWildcard(require("react"));
var _bignumber = require("bignumber.js");
var _Button = require("../../Button/Button");
require("./MaxButtonInput.css");
var _excluded = ["maxValue", "maxButtonSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/**
 * @typedef {import('../BaseNumberInput').BaseNumberInputProps} BaseNumberInputProps
 *
 * @typedef {Object} MaxInputProps
 * @property {number|string|BigNumber} maxValue Max value to set.
 *
 * @typedef {BaseNumberInputProps & MaxInputProps} NumberInputWithMaxProps
 */

function withMax(WrappedComponent) {
  /**
   * @param {NumberInputWithMaxProps} props
   * @param {React.Ref<import('../BaseNumberInput').BaseNumberInputRef>} ref
   */
  return /*#__PURE__*/(0, _react.forwardRef)(function NumberInputWithMax(_ref, ref) {
    var maxValue = _ref.maxValue,
      _ref$maxButtonSize = _ref.maxButtonSize,
      maxButtonSize = _ref$maxButtonSize === void 0 ? 'sm' : _ref$maxButtonSize,
      props = _objectWithoutProperties(_ref, _excluded);
    /**
     * @type {React.Ref<import('../BaseNumberInput').BaseNumberInputRef>}
     */
    var inputRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, function () {
      return inputRef.current;
    });
    var onMaxClick = (0, _react.useCallback)(function () {
      if (typeof maxValue !== 'undefined') {
        var _inputRef$current, _inputRef$current2;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || (_inputRef$current = _inputRef$current.inputEl) === null || _inputRef$current === void 0 || _inputRef$current.focus();
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setValue(new _bignumber.BigNumber(maxValue));
      }
    }, [maxValue]);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
      ref: inputRef
    })), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      className: "max-button",
      size: maxButtonSize,
      type: "button",
      onClick: onMaxClick
    }, "MAX"));
  });
}